export default "__VITE_ASSET___kEthyCq__"